import m from 'mithril';
import { appState } from '../lib/appState';

export class App {
    view(vnode) {
        return [m('main', { class: vnode.attrs.class} ,  vnode.children), m(appState.toaster)];
    }
}
